/**
 * Checks if the string is valid sitemap entry alias eg: uppercase and underscores
 * @param {string} str - A string that is checked against
 */
export const isStringAlias = (str = '') => {
	const r = new RegExp('^[A-Z0-9_]+$', 'g');
	return r.test(str);
};

/**
 * Determines if the string passed in is an absolute url
 * @param {string} str - A string that is checked against
 */
export const isStringAbsoluteUrl = (str = '') => {
	const r = new RegExp('^(?:[a-z]+:)?//', 'i');
	return r.test(str);
};

/**
 * Determines the url type passed in either as ALIAS, ABSOLUTE or RELATIVE
 * @param {string} url - A string value with a URL string or page alias
 */
export const determineUrlType = (url = '') => {
	if (isStringAlias(url)) {
		return 'ALIAS';
	} else if (isStringAbsoluteUrl(url)) {
		return 'ABSOLUTE';
	} else {
		return 'RELATIVE';
	}
};

/**
 * Sets the URL string based on sitemap request
 * Returns a string value after requesting a path from the sitemap service
 * @param {object} sitemap - An object containing helper functions for sitemap entries
 * @param {string} url - A string value with a URL string or page alias
 */
export const setUrl = (sitemap, url = '') => {
	switch (determineUrlType(url)) {
		case 'ALIAS':
			return sitemap.has(url) ? sitemap.get(url) : '/404.htm';
		default:
			return url || '/404.htm';
	}
};

/**
 * Builds URL parameters based on the values of the provided preferences.
 * @param {String} urlParams - A string value of comma-separated key-value pairs
 * @param {String} url - A string value with a URL string
 * @returns {String} - A string containing the URL parameters prefixed with the appropriate separator ('?' or '&'),
 * or an empty string if 'urlParams' is an empty string.
 */
export const setUrlParams = (urlParams, url) => {
	try {
		if (!urlParams) {
			return '';
		}

		const decodedUrlParams = decodeURIComponent(urlParams);

		const paramsToAppend = new URLSearchParams(
			decodedUrlParams.split(',').map((param) => param.trim().split('='))
		).toString();

		const separator = url.includes('?') ? '&' : '?';

		return `${separator}${paramsToAppend}`;
	} catch (err) {
		return '';
	}
};
